// BENDAGGI — dati prodotto (solo IT). Fonte: dati già presenti nel sito (migrati).
// NB: nessun dato inventato. Dove un campo non è disponibile viene omesso (nascosto).
// Struttura riutilizzabile e scalabile, coerente con lib/schiebler.js.

const HEALTH_NOTE =
  "Le informazioni riportate hanno carattere generale e non sostituiscono la valutazione del medico o del professionista sanitario. La scelta del prodotto e della configurazione deve essere effettuata sulla base delle indicazioni ricevute. La richiesta di informazioni non costituisce un ordine di acquisto.";

// Le 5 famiglie (categorie di prodotto, NON marchi).
export const BENDAGGI_FAMILIES = [
  {
    id: "adesivi",
    label: "Bende adesive",
    short:
      "Supporto muscolare, tendineo e articolare e fissaggio di medicazioni, con massa adesiva porosa e traspirante.",
  },
  {
    id: "coesivi",
    label: "Bende coesive",
    short:
      "Antiscivolo, per la fase di decongestione della terapia compressiva: si indossano per più giorni.",
  },
  {
    id: "non-adesivi",
    label: "Bende non adesive",
    short:
      "Elasticità corta, media e forte per terapia compressiva, ortopedia e medicina dello sport.",
  },
  {
    id: "ossido-zinco",
    label: "Bende all'ossido di zinco",
    short:
      "Medicazione elastica impregnata di pasta all'ossido di zinco, con proprietà lenitive, disinfettanti e cicatrizzanti.",
  },
  {
    id: "alginato",
    label: "Bende all'alginato",
    short:
      "Medicazione avanzata in fibre di alginato che si trasforma in gel a contatto con l'essudato, per ferite essudanti.",
  },
];

const MARRONE = { id: "marrone", name: "Marrone", hex: "#7A5230" };

export const BENDAGGI_PRODUCTS = [
  // ---------------- BENDE ADESIVE ----------------
  {
    slug: "wero-swiss-adesiva",
    id: "bnd-adesiva",
    family: "adesivi",
    name: "Benda adesiva",
    brand: "Wero Swiss",
    tipologia: "Adesivo",
    tag: "Dispositivo medico",
    title: "Benda elastica adesiva porosa per supporto e fissaggio",
    cover: "/products/bendaggi/wero-swiss-adesiva.webp",
    photos: [{ src: "/products/bendaggi/wero-swiss-adesiva.webp" }],
    short:
      "Supporto muscolare, tendineo e articolare e fissaggio di medicazioni, con massa adesiva porosa.",
    description:
      "Benda elastica adesiva porosa. Svolge una funzione di supporto nel trattamento di patologie muscolari, tendinee ed articolari, nel trattamento elastocompressivo di patologie vascolari dell'arto inferiore e nel fissaggio di medicazioni.",
    features: [
      "Massa adesiva porosa e traspirante per ridurre il rischio di macerazione",
      "Tessuto altamente estendibile, conformabile e assorbente",
      "Linea centrale gialla per una maggiore precisione nell'applicazione",
    ],
    characteristics:
      "Tessuto altamente estendibile, conformabile, assorbente e termoregolato. Massa adesiva porosa spalmata omogeneamente per una corretta traspirazione cutanea, riducendo il rischio di macerazione. Linea centrale gialla per una maggiore precisione nell'applicazione.",
    material: [["Cotone", "58%"], ["Viscosa", "42%"], ["Adesivo", "Lattice naturale"]],
    widths: ["5 cm", "7,5 cm", "10 cm"],
    lengths: ["4,5 m"],
    storage: "A temperatura non superiore ai 25°C.",
    warnings:
      "Contiene gomma naturale: possibili reazioni allergiche in soggetti predisposti.",
    properties: [
      "Tessuto traspirante, permeabile ad aria e vapore, anche in bendaggi multistrato",
      "Adesione stabile alla cute per ancoraggi e tiranti sicuri",
      "Elevata conformabilità ed estensibilità per adattarsi alle articolazioni",
      "Si fissa direttamente sulla pelle, senza clip o fermagli",
    ],
    indications: [
      "Bendaggio funzionale in ambito sportivo e riabilitativo",
      "Supporto e immobilizzazione parziale di distorsioni, contusioni e tendinopatie",
      "Trattamento elastocompressivo di patologie vascolari dell'arto inferiore",
      "Fissaggio di medicazioni",
    ],
    faq: [
      ["Che differenza c'è tra benda adesiva e benda coesiva?", "La benda adesiva aderisce direttamente alla pelle grazie a uno strato di collante, creando ancoraggi stabili; la benda coesiva aderisce invece solo a se stessa, non alla cute né ai peli. La scelta dipende dall'uso e dalla sensibilità cutanea."],
      ["È traspirante?", "Sì. La massa adesiva è spalmata in modo poroso, così il tessuto resta permeabile ad aria e vapore e riduce il rischio di macerazione, anche in bendaggi multistrato."],
      ["Può causare allergie?", "Questa benda contiene gomma naturale (lattice): in soggetti predisposti sono possibili reazioni allergiche. Va applicata su cute integra e dopo valutazione del professionista."],
      ["Si può bagnare?", "In genere le bende adesive non vanno bagnate e richiedono attenzione nel monitoraggio della circolazione periferica. Segui le indicazioni del prodotto e del professionista sanitario."],
    ],
    device: true,
    healthNote: HEALTH_NOTE,
  },

  // ---------------- BENDE COESIVE ----------------
  {
    slug: "wero-swiss-lan-cohesive",
    id: "bnd-coesiva",
    family: "coesivi",
    name: "Lan Cohesive",
    brand: "Wero Swiss",
    fullName: "Wero Swiss® Lan Cohesive (Lan K-26)",
    tipologia: "Coesivo",
    tag: "Elasticità molto ridotta",
    title: "Benda coesiva a elasticità molto ridotta",
    cover: "/products/bendaggi/wero-swiss-lan-cohesive.webp",
    photos: [{ src: "/products/bendaggi/wero-swiss-lan-cohesive.webp" }],
    short:
      "Antiscivolo, per la fase di decongestione della terapia compressiva: si indossa per 3–5 giorni.",
    description:
      "Benda compressiva coesiva a elasticità molto ridotta. Grazie al rivestimento coesivo è antiscivolo e va indossata per un periodo compreso tra tre e cinque giorni. Si utilizza, con un'imbottitura idonea, durante la fase di decongestione della terapia compressiva; adatta anche alla cura post-operatoria in ortopedia e al supporto in medicina dello sport.",
    features: [
      "Brevissimo allungamento per un'elevata pressione di lavoro",
      "Rivestimento coesivo per un utilizzo da tre a cinque giorni",
    ],
    material: [["Cotone", "100%"]],
    colors: [MARRONE],
    stretch: "50%",
    widths: ["4 cm", "6 cm", "8 cm", "10 cm", "12 cm"],
    lengths: ["5 m"],
    properties: [
      "Aderisce solo a se stessa, non alla pelle né ai peli: rimozione indolore",
      "Compressione costante e stabile, effetto antiscivolo",
      "Non richiede clip o fermagli",
      "Traspirante e confortevole, adatta anche a pelli sensibili",
    ],
    indications: [
      "Fase di decongestione della terapia compressiva (con imbottitura idonea)",
      "Cura post-operatoria in ortopedia",
      "Supporto leggero di articolazioni (caviglia, ginocchio, polso)",
      "Fissaggio di medicazioni",
    ],
    faq: [
      ["Perché si chiama coesiva?", "Perché aderisce esclusivamente a se stessa, sovrapponendo i giri, senza attaccarsi alla cute, ai peli o ai vestiti. Questo rende la rimozione atraumatica."],
      ["Per quanti giorni si può tenere?", "Grazie al rivestimento coesivo antiscivolo può essere indossata per un periodo indicativamente compreso tra tre e cinque giorni, secondo l'indicazione del professionista."],
      ["È adatta alle pelli sensibili?", "Sì: non contenendo adesivi a contatto con la pelle, è indicata anche per cute sensibile o zone ricoperte di peluria."],
      ["Come va applicata?", "Si avvolge la zona sovrapponendo leggermente i giri e facendo aderire la benda su se stessa, con attenzione alla tensione per non compromettere la circolazione. L'applicazione va eseguita o guidata da personale sanitario."],
    ],
    device: true,
    healthNote: HEALTH_NOTE,
  },

  // ---------------- BENDE NON ADESIVE ----------------
  {
    slug: "wero-swiss-forte",
    id: "bnd-forte",
    family: "non-adesivi",
    name: "Forte",
    brand: "Wero Swiss",
    fullName: "Wero Swiss® Forte",
    tipologia: "Non adesivo",
    tag: "Elasticità forte",
    title: "Benda elastica a lunga elasticità",
    cover: "/products/bendaggi/wero-swiss-forte.webp",
    photos: [{ src: "/products/bendaggi/wero-swiss-forte.webp" }],
    short:
      "Benda compressiva potente, resistente ed elastica, con elevata capacità di allungamento.",
    description:
      "Benda compressiva potente, resistente ed elastica, con elevata capacità di allungamento. Adatta alla cura post-operatoria in ortopedia, al supporto funzionale e di sollievo e al riassorbimento di ematomi dopo contusioni, distorsioni e lussazioni.",
    features: [
      "Trama fitta e alta grammatura per un supporto forte e duraturo",
      "Adatta a immobilizzare parti del corpo molto mobili",
      "Lavabile e riutilizzabile più volte",
    ],
    material: [["Cotone", "93%"], ["Poliuretano", "7%"]],
    colors: [MARRONE],
    stretch: "175%",
    widths: ["6 cm", "8 cm", "10 cm", "12 cm", "15 cm", "20 cm"],
    lengths: ["7 m"],
    properties: [
      "Elevata capacità di allungamento (lunga elasticità)",
      "Alta pressione di riposo per un supporto forte e duraturo",
      "Trama fitta e alta grammatura",
      "Lavabile e riutilizzabile più volte",
    ],
    indications: [
      "Cura post-operatoria in ortopedia",
      "Supporto funzionale e di sollievo",
      "Riassorbimento di ematomi dopo contusioni, distorsioni e lussazioni",
      "Immobilizzazione di parti del corpo molto mobili",
    ],
    faq: [
      ["Cosa significa «lunga elasticità»?", "Indica una benda molto estensibile che esercita una pressione di riposo elevata; è adatta al supporto e al contenimento, soprattutto in pazienti a riposo."],
      ["Si può lavare e riutilizzare?", "Sì, è lavabile e riutilizzabile più volte mantenendo le sue proprietà."],
      ["Che differenza c'è rispetto a Medium e Texelast?", "Cambia il grado di allungamento: Forte ha lunga elasticità, Medium un'elasticità media, Texelast una corta estensibilità. La scelta dipende dall'uso e dall'indicazione del professionista."],
    ],
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "wero-swiss-medium",
    id: "bnd-medium",
    family: "non-adesivi",
    name: "Medium",
    brand: "Wero Swiss",
    fullName: "Wero Swiss® Medium",
    tipologia: "Non adesivo",
    tag: "Elasticità media",
    title: "Benda elastica a media elasticità",
    cover: "/products/bendaggi/wero-swiss-medium.webp",
    photos: [{ src: "/products/bendaggi/wero-swiss-medium.webp" }],
    short:
      "Benda compressiva a elasticità duratura, con elasticità media e potente.",
    description:
      "Benda compressiva a elasticità duratura, con elasticità media e potente. Indicata per la cura post-operatoria in ortopedia, per medicazioni di supporto e sollievo e per il riassorbimento di ematomi, distorsioni e lussazioni.",
    features: [
      "Superficie liscia e fine, resistente a sudore e unguenti",
      "Pressione di riposo elevata e facilmente regolabile",
      "Lavabile e riutilizzabile",
    ],
    material: [["Cotone", "83%"], ["Poliammide", "14%"], ["Poliuretano", "3%"]],
    colors: [MARRONE],
    stretch: "145%",
    widths: ["6 cm", "8 cm", "10 cm", "12 cm", "15 cm"],
    lengths: ["5 m", "7 m"],
    properties: [
      "Elasticità media e duratura",
      "Pressione di riposo elevata e facilmente regolabile",
      "Superficie liscia e fine, resistente a sudore e unguenti",
      "Lavabile e riutilizzabile",
    ],
    indications: [
      "Cura post-operatoria in ortopedia",
      "Medicazioni di supporto e sollievo",
      "Riassorbimento di ematomi, distorsioni e lussazioni",
    ],
    faq: [
      ["Quando si preferisce una benda a media elasticità?", "Quando serve un supporto regolabile con una buona pressione di riposo; l'indicazione precisa spetta al professionista sanitario."],
      ["Resiste a sudore e pomate?", "Sì: la superficie liscia e fine la rende resistente a sudore e unguenti."],
      ["È riutilizzabile?", "Sì, è lavabile e riutilizzabile mantenendo le sue caratteristiche."],
    ],
    device: true,
    healthNote: HEALTH_NOTE,
  },
  {
    slug: "wero-swiss-texelast",
    id: "bnd-texelast",
    family: "non-adesivi",
    name: "Texelast",
    brand: "Wero Swiss",
    fullName: "Wero Swiss® Texelast",
    tipologia: "Non adesivo",
    tag: "Elasticità corta",
    title: "Benda elastica a corta elasticità",
    cover: "/products/bendaggi/wero-swiss-texelast.webp",
    photos: [{ src: "/products/bendaggi/wero-swiss-texelast.webp" }],
    short:
      "Benda compressiva a elasticità duratura con allungamento molto breve.",
    description:
      "Benda compressiva a elasticità duratura con allungamento molto breve, utilizzata da specialisti qualificati nei casi di insufficienza vascolare accentuata (insufficienza venosa cronica, vene varicose, ulcere, flebosclerosi, edema, tromboflebite e cura post-operatoria dopo interventi alle vene).",
    features: [
      "Brevissimo allungamento per un'elevata pressione di lavoro",
      "Fissaggio terminale senza lattice che previene lo sfilacciamento",
      "Lavabile e riutilizzabile, con clip per il trasporto",
    ],
    material: [["Cotone", "67%"], ["Poliammide", "33%"]],
    colors: [MARRONE],
    stretch: "40%",
    widths: ["6 cm", "8 cm", "10 cm", "12 cm"],
    lengths: ["5 m"],
    properties: [
      "Corta estensibilità: bassa pressione di riposo ed elevata pressione di lavoro",
      "Durante la contrazione muscolare agisce come una «pompa», favorendo il ritorno venoso e linfatico",
      "Ben tollerata a riposo",
      "Impiegata nei bendaggi multistrato con imbottitura idonea",
    ],
    indications: [
      "Terapia compressiva degli arti inferiori",
      "Gestione dell'edema e del linfedema (fase di trattamento)",
      "Ulcere da stasi venosa (bendaggio elastocontenitivo)",
      "Pazienti deambulanti (compressione attiva durante il movimento)",
    ],
    faq: [
      ["Cosa significa «corta estensibilità»?", "È una benda poco estensibile che esercita una bassa pressione a riposo e un'elevata pressione durante il movimento (pressione di lavoro), utile nella terapia compressiva."],
      ["A cosa serve l'elevata pressione di lavoro?", "Durante la deambulazione la benda si oppone all'espansione del muscolo, creando picchi di pressione che favoriscono il ritorno dei fluidi. Per questo è indicata soprattutto nei pazienti deambulanti."],
      ["Chi deve applicarla?", "Il bendaggio compressivo è operatore-dipendente e richiede competenza specifica: va eseguito o guidato da personale sanitario, con pressione decrescente dalla caviglia verso l'alto."],
      ["Quando è controindicata?", "In presenza di alcune condizioni (ad esempio arteriopatia periferica significativa, scompenso cardiaco, infezioni o dermatiti locali) la compressione può essere controindicata: è indispensabile la valutazione del medico."],
    ],
    device: true,
    healthNote: HEALTH_NOTE,
  },

  // ---------------- BENDE ALL'OSSIDO DI ZINCO ----------------
  {
    slug: "benda-ossido-di-zinco",
    id: "bnd-ossido-zinco",
    family: "ossido-zinco",
    name: "Benda all'ossido di zinco",
    tipologia: "Ossido di zinco",
    tag: "Medicazione elastica",
    title: "Medicazione elastica impregnata di pasta all'ossido di zinco",
    short:
      "Medicazione elastica non sterile impregnata di pasta all'ossido di zinco, con proprietà lenitive, disinfettanti e cicatrizzanti.",
    description:
      "La benda all'ossido di zinco è una medicazione elastica terapeutica utilizzata in ambito medico e fisioterapico per le sue proprietà lenitive, disinfettanti e cicatrizzanti. È composta da una benda elastica non sterile, completamente impregnata con una pasta ricca di ossido di zinco, impiegata nel trattamento di lesioni cutanee croniche, ulcere venose, traumi e infiammazioni. Rappresenta un'alternativa alla gessatura tradizionale, con maggiore comfort per il paziente.",
    features: [
      "Alta aderenza senza eccessiva compressione",
      "Facilità di rimozione",
      "Bordi morbidi e resistenti che evitano l'«effetto laccio»",
      "Ottima traspirabilità, per ridurre fastidi e prurito",
    ],
    properties: [
      "Effetto lenitivo e antinfiammatorio",
      "Azione antibatterica e disinfettante",
      "Adesione stabile anche per lunghi periodi",
      "Alta tollerabilità cutanea, anche per pelli sensibili",
    ],
    indications: [
      "Traumi sportivi (distorsioni, strappi, ematomi)",
      "Vene varicose e insufficienza venosa",
      "Ulcere venose degli arti inferiori",
      "Fasi post-gesso e riabilitazione",
      "Tendiniti, artrosi e artriti",
      "Edema e versamenti linfatici",
    ],
    layers: [
      ["Strato interno", "la benda impregnata con ossido di zinco"],
      ["Strato intermedio", "cotone o gommapiuma, per ammortizzare la compressione"],
      ["Strato esterno", "benda elastica autoadesiva"],
    ],
    types: [
      ["Bendaggio elastocompressivo", "Indicato per pazienti immobili o allettati; crea una compressione terapeutica utile in caso di insufficienza venosa cronica, edema interstiziale e ulcere da stasi venosa, con effetto sul macro e microcircolo e miglioramento del flusso sanguigno e linfatico."],
      ["Bendaggio elastocontenitivo", "Più adatto ai pazienti deambulanti; utilizza bende a corta estensibilità per una compressione stabile durante il movimento e una riduzione dell'edema senza eccessiva pressione a riposo, con comfort nelle terapie a lungo termine."],
    ],
    application: [
      "Applicare una compressione decrescente dalla caviglia verso il polpaccio",
      "Evitare pieghe per non causare lesioni",
      "Mantenere la corretta posizione dell'arto",
      "Fissare il bendaggio in modo stabile ma non costrittivo",
    ],
    faq: [
      ["Il bendaggio all'ossido di zinco fa male?", "No. Al contrario, ha proprietà lenitive e contribuisce ad alleviare dolore e infiammazione cutanea. È generalmente ben tollerato anche da chi ha la pelle sensibile."],
      ["Quanto dura un bendaggio all'ossido di zinco?", "Può restare applicato da 2 a 7 giorni, a seconda della condizione e delle indicazioni del medico."],
      ["È adatto anche a bambini o anziani?", "Sì: grazie alla sua delicatezza può essere utilizzato su pelli fragili, inclusi bambini e pazienti geriatrici, sempre secondo indicazione sanitaria."],
      ["Per quanto tempo va tenuta la benda?", "I tempi di permanenza dipendono dalla situazione e dal tipo di trattamento. È importante seguire le indicazioni del medico o quelle specifiche del prodotto per evitare irritazioni o altri problemi."],
      ["Va bene per le infiammazioni?", "L'ossido di zinco è noto per le proprietà lenitive e protettive ed è spesso utilizzato in caso di infiammazioni cutanee dovute a irritazioni o lesioni superficiali; può contribuire a ridurre il dolore e a favorire la guarigione."],
      ["A cosa serve?", "È usata principalmente per proteggere, sostenere e trattare piccole ferite, contusioni e distorsioni, e per lenire irritazioni cutanee, oltre a favorire la guarigione di escoriazioni."],
    ],
    cover: "/products/bendaggi/benda-ossido-di-zinco.jpg",
    photos: [{ src: "/products/bendaggi/benda-ossido-di-zinco.jpg" }],
    device: true,
    healthNote: HEALTH_NOTE,
  },

  // ---------------- MEDICAZIONI IN ALGINATO ----------------
  {
    slug: "benda-alginato",
    id: "bnd-alginato",
    family: "alginato",
    name: "Medicazione in alginato",
    tipologia: "Alginato",
    tag: "Medicazione avanzata",
    title: "Medicazione in fibre di alginato per ferite essudanti",
    short:
      "Medicazione avanzata in fibre di alginato di calcio che si trasforma in gel a contatto con l'essudato, per lesioni da moderatamente a fortemente essudanti.",
    description:
      "Le piaghe da decubito fortemente essudanti richiedono medicazioni avanzate capaci di assorbire grandi quantità di liquido, mantenere un ambiente umido e favorire la guarigione. Le medicazioni in alginato sono tra le più utilizzate grazie alla loro capacità di trasformarsi in gel a contatto con l'essudato, proteggendo i tessuti e semplificando la rimozione.",
    features: [
      "Elevata capacità di assorbimento dell'essudato",
      "Formazione di un gel morbido che mantiene l'ambiente umido",
      "Rimozione atraumatica: non aderisce alla ferita",
      "Fibre naturali biocompatibili, senza lattice (latex-free)",
    ],
    properties: [
      "Fibre naturali derivate dalle alghe marine",
      "A contatto con l'essudato si trasformano in un gel morbido e biocompatibile",
      "Assorbono grandi quantità di liquido",
      "Favoriscono lo sbrigliamento naturale",
      "Non aderiscono alla ferita, per una rimozione atraumatica",
    ],
    indications: [
      "Piaghe da decubito",
      "Ulcere degli arti inferiori",
      "Ferite chirurgiche con essudato abbondante",
      "Ustioni di secondo grado",
      "Lesioni da moderatamente a fortemente essudanti",
    ],
    faq: [
      ["Cosa sono le medicazioni in alginato?", "Sono composte da fibre di alginato di calcio, un polisaccaride naturale estratto dalle alghe marine. Si trasformano in gel a contatto con l'essudato, mantenendo la ferita umida e favorendo la guarigione."],
      ["Per quali ferite sono indicate?", "Sono indicate per lesioni da moderatamente a fortemente essudanti, come piaghe da decubito, ulcere degli arti inferiori o ferite chirurgiche, grazie alla capacità di assorbire grandi quantità di essudato senza danneggiare il tessuto circostante."],
      ["Quanto tempo possono rimanere applicate?", "A seconda della quantità di essudato, possono rimanere in sede fino a 7 giorni, mantenendo un ambiente umido e proteggendo la ferita da macerazione o traumi alla rimozione."],
      ["Come si sceglie la medicazione giusta?", "La scelta dipende dal livello di essudato e dalla profondità della ferita. Consulta sempre le specifiche tecniche del prodotto e il parere del medico."],
      ["Le medicazioni in alginato sono sicure per tutti?", "Sono generalmente sicure e non contengono lattice (latex-free). È comunque consigliato seguire le indicazioni del medico e verificare eventuali allergie specifiche."],
    ],
    cover: "/products/bendaggi/benda-alginato.jpg",
    photos: [{ src: "/products/bendaggi/benda-alginato.jpg" }],
    device: true,
    healthNote: HEALTH_NOTE,
  },
];

export const getBendaggioProduct = (slug) =>
  BENDAGGI_PRODUCTS.find((p) => p.slug === slug);

export const familyLabel = (id) =>
  BENDAGGI_FAMILIES.find((f) => f.id === id)?.label || "Bendaggi";

// Famiglie con i prodotti raggruppati.
export const bendaggiByFamily = () =>
  BENDAGGI_FAMILIES.map((f) => ({
    ...f,
    products: BENDAGGI_PRODUCTS.filter((p) => p.family === f.id),
  }));

// Altri prodotti della stessa famiglia.
export const relatedBendaggi = (product) =>
  BENDAGGI_PRODUCTS.filter(
    (p) => p.family === product.family && p.slug !== product.slug
  );

// Voci per il catalogo generale /prodotti (ogni bendaggio come prodotto singolo).
export const bendaggiCatalog = () =>
  BENDAGGI_PRODUCTS.map((p) => ({
    id: p.id,
    cats: ["bendaggi"],
    family: p.family,
    catLabel: "Bendaggi",
    name: p.name,
    brand: p.brand,
    img: p.cover ?? null,
    short: p.short,
    to: `/prodotti/bendaggi/${p.slug}`,
  }));
